import BreadCrumb from "Components/Common/BreadCrumb";
import Loader from "Components/Common/Loader";
import TableContainer from "Components/Common/TableContainer";
import { adminGetAllInsurance } from "helpers/backend_helpers";
import { formatCurrency, formatDateTime } from "helpers/globalFunction";
import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import AddModalInsurance from "./AddModalInsurance";
import DeleteModalInsurance from "./DeleteModalInsurance";
import UpdateModalInsurance from "./UpdateModalInsurance";

const InsuranceData = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [sort, setSort] = useState("createTime");
  const [dir, setDir] = useState(-1);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [addModal, setAddModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const getData = () => {
    setLoading(true);
    let query: any = {
      page: pagination.pageIndex,
      size: pagination.pageSize,
      sort: sort,
      dir: dir,
    };

    adminGetAllInsurance(query)
      .then((response: any) => {
        setTableData(
          response.content.map((el: any, index: any) => {
            let dibuat = formatDateTime(el.createTime);
            let diperbarui = formatDateTime(el.updateTime);
            return {
              ...el,
              index: index + pagination.pageIndex * pagination.pageSize + 1,
              dibuat,
              diperbarui,
            };
          }),
        );
        setRowCount(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "index",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Nama",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
      },
      // {
      //   header: "Kategori",
      //   accessorKey: "category",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: (cell: any) => insuranceCategory(cell.getValue()),
      // },
      {
        header: "Nominal",
        accessorKey: "amount",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => formatCurrency(cell.getValue()),
      },
      {
        header: "Deskripsi",
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Status",
        accessorKey: "isActive",
        enableColumnFilter: false,
        enableSorting: false,
        size: 100,
        cell: (cell: any) => {
          switch (cell.getValue()) {
            case true:
              return (
                <span className="badge text-uppercase bg-success-subtle text-success">
                  Aktif
                </span>
              );
            case false:
              return (
                <span className="badge text-uppercase bg-danger-subtle text-danger">
                  Tidak Aktif
                </span>
              );
            default:
              return (
                <span className="badge text-uppercase bg-info-subtle text-info">
                  -
                </span>
              );
          }
        },
      },
      {
        header: "Dibuat",
        accessorKey: "dibuat",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Diperbarui",
        accessorKey: "diperbarui",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Aksi",
        cell: (cellProps: any) => {
          return (
            <div className="hstack gap-2">
              <UncontrolledTooltip
                target={`edit-${cellProps.row.original._id}`}
              >
                Edit
              </UncontrolledTooltip>
              <button
                id={`edit-${cellProps.row.original._id}`}
                className="btn btn-sm btn-soft-warning edit-list"
                onClick={() => {
                  setUpdateModal(true);
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-pencil-fill align-bottom" />
              </button>

              <UncontrolledTooltip
                target={`delete-${cellProps.row.original._id}`}
              >
                Hapus
              </UncontrolledTooltip>
              <button
                id={`delete-${cellProps.row.original._id}`}
                className="btn btn-sm btn-soft-danger remove-list"
                onClick={() => {
                  setDeleteModal(true);
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-delete-bin-5-fill align-bottom" />
              </button>
            </div>
          );
        },
      },
    ],
    [],
  );

  useEffect(() => {
    getData();
  }, [pagination, sort, dir]);

  document.title = "Asuransi";

  return (
    <React.Fragment>
      <div className="page-content">
        <AddModalInsurance
          show={addModal}
          onCloseClick={() => setAddModal(false)}
          getData={() => getData()}
        />
        <UpdateModalInsurance
          show={updateModal}
          onCloseClick={() => setUpdateModal(false)}
          getData={() => getData()}
          data={data}
        />
        <DeleteModalInsurance
          show={deleteModal}
          onCloseClick={() => setDeleteModal(false)}
          getData={() => getData()}
          data={data}
          setData={() => setData({})}
        />
        <Container fluid>
          <BreadCrumb title="Data Asuransi" pageTitle="Gaji" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0 flex-grow-1">
                      Data Asuransi
                    </h5>
                    <div className="flex-shrink-0">
                      <div className="d-flex gap-2 flex-wrap">
                        {/* <button
                          className="btn btn-soft-primary btn-sm"
                          onClick={handleToggleFilter}
                        >
                          <i className="ri-filter-3-line align-bottom me-1"></i>
                          Filters
                        </button> */}
                        <div
                          className="btn btn-soft-success btn-sm"
                          onClick={() => {
                            setAddModal(true);
                          }}
                        >
                          <i className="ri-add-line align-bottom me-1"></i>{" "}
                          Tambah
                        </div>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-0">
                  {/* <Collapse isOpen={showFilter}>
                    <Row className="g-3 mb-4">
                      <Col lg={4}>
                        <div>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Cari nama..."
                            value={filterName}
                            onChange={(e) => setFilterName(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-soft-secondary btn-sm"
                            onClick={handleResetFilter}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>
                            Reset
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Collapse> */}
                  <div>
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={tableData || []}
                        customPageSize={10}
                        theadClass="text-muted text-uppercase"
                        manualPagination
                        pagination={pagination}
                        pageCount={totalPages}
                        onPaginationChange={setPagination}
                        divClass="table-responsive"
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default InsuranceData;
